import React, { memo } from 'react';
import { withRouter } from 'react-router-dom';
import { RequestProvider } from '@shootsta/common-react';

import SplashNavigator from '../components/SplashNavigator';

import { getSplashPageApi } from '../api';

import { GraphqlResponse } from '../types';

interface Requests {
  // eslint-disable-next-line react/no-unused-prop-types
  getSplashPage: (id?: string) => Promise<GraphqlResponse>;
}

interface ShareablePageProps {
  match: { params: { id: string } };
}

function SplashPageContainer({
  match: {
    params: { id }
  }
}: ShareablePageProps) {
  return (
    <RequestProvider
      requests={{
        getSplashPage: getSplashPageApi(id)
      }}
    >
      {({
        getSplashPage
      }: Requests) => (
        <SplashNavigator
          getSplashPage={getSplashPage}
          splashPageId={id}
        />
      )}
    </RequestProvider>
  );
}

export default memo(withRouter(SplashPageContainer));
